module.exports = __webpack_public_path__ + "images/external_images/svg/shapes/shape3.svg";